export const SECTORS = Array.from({ length: 12 }, (_, i) => i + 1);

export const RESOURCE_TYPES = {
  CREDITS: 'credits',
  INCOME: 'income',
  VP: 'vp',
};

// Reward "kinds" a station/deployed slot can be. TEXT rewards carry their
// mechanical meaning in `effect` (claim a card, buy a card) - they're
// still one-shot grants, not chargeable abilities (see ABILITY_TIMING).
export const REWARD_KINDS = {
  CREDITS: 'credits',
  INCOME: 'income',
  VP: 'vp',
  TEXT: 'text',
};

// Ability usability windows (rulebook "Reference" page). Blue = active
// player's own turn only. Red = passive players (opponents), on the
// active player's turn. Green = anyone, any turn. This is independent of
// which slot (station/deployed) the ability's charge squares live in -
// charging is always blue-on-your-turn for station squares and
// red-on-opponent's-turn for deployed squares (see chargeSlotFor below),
// but the ABILITY's own usable-timing can differ (a green-timed ability
// can still have blue-only-chargeable squares).
export const ABILITY_TIMING = {
  BLUE: 'blue',
  RED: 'red',
  GREEN: 'green',
};

// Arrow reward directions ("Arrow Rewards", rulebook p19) - shifts which
// sector's reward you actually gain instead of the card's own sector.
export const ARROW_DIRECTIONS = {
  LEFT: 'left',
  RIGHT: 'right',
  BOTH: 'both',
};

// The full taxonomy of one-shot text-reward / chargeable-ability effects
// described in the rulebook's "Ability Cards in Detail" / "Ability
// Clarifications" sections (pages 20-27). A card's `effect` field always
// has one of these `kind`s.
export const EFFECT_KINDS = {
  BUY_CARD: 'buyCard',
  BUY_CARD_SECTOR_RANGE: 'buyCardSectorRange',
  CLAIM_CARD: 'claimCard',
  DOUBLE_STATION_REWARD: 'doubleStationReward',
  DOUBLE_DEPLOY_REWARD: 'doubleDeployReward',
  PLACE_CHARGE_ANYWHERE: 'placeChargeAnywhere',
  REROLL_DICE: 'rerollDice',
  ALL_OPPONENTS_LOSE_VP: 'allOpponentsLoseVP',
  PLACE_CARD_SECTOR_RANGE: 'placeCardSectorRange', // no transcribed card uses this yet - kept for the first card that does (backlog item 12)
  SET_DICE: 'setDice',
  EXCHANGE_CARD: 'exchangeCard',
  SWAP_SECTORS: 'swapSectors',
  YOU_WIN: 'youWin',
  DICE_ARROW_SHIFT: 'diceArrowShift',
};

export const SHIPYARD_LEVELS = [1, 2, 3];

// Turn-order starting bonuses (rulebook p10, "Determine Starting Player").
// Index 0 = starting player (gets nothing).
export const TURN_ORDER_BONUSES = [
  null,
  { type: RESOURCE_TYPES.CREDITS, amount: 1 },
  { type: RESOURCE_TYPES.CREDITS, amount: 2 },
  { type: RESOURCE_TYPES.INCOME, amount: 1 },
  { type: RESOURCE_TYPES.INCOME, amount: 1 },
];

export const STARTING_CREDITS = 5;
export const WIN_VP_THRESHOLD = 40;
export const TRACK_WRAP = 40;
export const SHIPYARD_DISPLAY_SIZE = 6;

// A charge square that must be filled "if and only if" playerCount <= the
// pip count shown on it (rulebook p21's worked example - the literal
// one-line summary in the rules is a simplification of this threshold,
// see docs/card-audit.md). `pip: null` means "always required."
export function squareRequiredAtPlayerCount(pip, playerCount) {
  if (pip === null || pip === undefined) return true;
  return playerCount <= pip;
}
